import script from "./attendance-policy-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./attendance-policy-settings.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__